/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Photos_Input_LabelInputs */

const en_admin_resources_photos_input_label = /** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More photos`)
};

const de_admin_resources_photos_input_label = /** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Fotos`)
};

const es_admin_resources_photos_input_label = /** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más fotos`)
};

const fr_admin_resources_photos_input_label = /** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de photos`)
};

/** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */
const it_admin_resources_photos_input_label = en_admin_resources_photos_input_label;

/** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */
const pt_br2_admin_resources_photos_input_label = en_admin_resources_photos_input_label;

/** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */
const pl_admin_resources_photos_input_label = en_admin_resources_photos_input_label;

/** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */
const hu_admin_resources_photos_input_label = en_admin_resources_photos_input_label;

/** @type {(inputs: Admin_Resources_Photos_Input_LabelInputs) => LocalizedString} */
const ro_admin_resources_photos_input_label = en_admin_resources_photos_input_label;

/**
* | output |
* | --- |
* | "More photos" |
*
* @param {Admin_Resources_Photos_Input_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_photos_input_label = /** @type {((inputs?: Admin_Resources_Photos_Input_LabelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Photos_Input_LabelInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_photos_input_label(inputs)
	if (locale === "de") return de_admin_resources_photos_input_label(inputs)
	if (locale === "es") return es_admin_resources_photos_input_label(inputs)
	if (locale === "fr") return fr_admin_resources_photos_input_label(inputs)
	if (locale === "it") return it_admin_resources_photos_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_photos_input_label(inputs)
	if (locale === "pl") return pl_admin_resources_photos_input_label(inputs)
	if (locale === "hu") return hu_admin_resources_photos_input_label(inputs)
	return ro_admin_resources_photos_input_label(inputs)
});
export { admin_resources_photos_input_label as "admin.resources.photos_input.label" }